var info_boxes = document.querySelectorAll('.info-box');

info_boxes.forEach(function(info_box){
  var trigger = info_box.querySelector('.info-box__hl');

  trigger.addEventListener('click', (e)=>{
    if (info_box.classList.contains('is-open')) {
      info_box.classList.remove('is-open');
    } else {
      info_box.classList.add('is-open');
    }
  });
});





